import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import * as db from '@/lib/data-service';
import { Heart } from 'lucide-react';

export default function Matches() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    if (user) {
      (async () => {
        await db.syncFromSupabase(user.id);
        setMatches(db.getMatches(user.id));
      })();
    }
  }, [user]);

  return (
    <div className="h-full overflow-auto bg-background" data-testid="matches-screen">
      <div className="p-4">
        <h1 className="text-xl font-bold text-foreground mb-4">Matches</h1>
        {matches.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="matches-empty">
            <Heart className="h-12 w-12 text-[#D3D0CB] mb-4" />
            <p className="text-lg font-medium text-foreground">No matches yet</p>
            <p className="text-sm text-[#7A7672] mt-1">Keep exploring to find your match</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {matches.map(m => {
              const p = m.otherProfile;
              const photo = m.otherPhotos?.[0];
              const diff = Date.now() - new Date(m.created_at).getTime();
              const timeSince = diff < 3600000 ? `${Math.floor(diff/60000)}m` : diff < 86400000 ? `${Math.floor(diff/3600000)}h` : `${Math.floor(diff/86400000)}d`;
              return (
                <button key={m.id} onClick={() => navigate(`/messages/${m.id}`)}
                  className="relative rounded-[16px] overflow-hidden border border-border bg-card aspect-[3/4] text-left card-hover"
                  data-testid={`match-card-${m.id}`}>
                  {photo ? <img src={photo.url} className="w-full h-full object-cover no-screenshot" alt={p?.display_name} onContextMenu={(e) => e.preventDefault()} draggable={false} />
                    : <div className="w-full h-full bg-[#F0EDE9] flex items-center justify-center"><span className="text-3xl font-bold text-[#D3D0CB]">{p?.display_name?.[0]}</span></div>}
                  <div className="absolute bottom-0 left-0 right-0 p-3" style={{ background: 'linear-gradient(to top, rgba(26,24,20,0.70) 0%, transparent 100%)' }}>
                    <p className="text-white text-sm font-semibold">{p?.display_name}</p>
                    <p className="text-white/70 text-xs">{timeSince} ago</p>
                  </div>
                  {m.messageCount === 0 && <div className="absolute top-2 right-2 w-3 h-3 bg-[#C857A8] rounded-full" />}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
